import { Button, Table, Typography } from "antd"
import React, { useEffect, useState } from "react"
import moment from "moment"

//react router dom's link as Redirect due to antd Typography Link
import { Link as Redirect } from "react-router-dom"
import { designerUsersFilter } from "../../../components/Filters/TableFilters"
import { collection, onSnapshot, orderBy, query, where } from "firebase/firestore"
import { db } from "../../../firebase/config"
import { returnProperMachineTag } from "../../../components/utils/ReturnProperMachineTag"
import TapeOrderFill from "./Details/TapeOrderFill"
import { OrderAndPrefix } from "../../../components/Orders/Helpers/OrderAndPrefix"
import FillStopRequest from "../../../components/PaperManager/Orders/Action/FillStopRequest"
import CutterDetails from "./Details/CutterDetails"

const { Text, Link } = Typography

export default function ActiveDesignerOrdersTable(props) {
  //active orders data
  const [activeOrders, setActiveOrders] = useState([])
  const [activeOrdersLoading, setActiveOrdersLoading] = useState(false)

  //gets data from active orders for designer
  useEffect(() => {
    if (props.activeKey === 1) {
      setActiveOrdersLoading(true)
      //ref for notifications
      const ordersRef = collection(db, "orders")

      // query
      const activeQ = query(ordersRef, where("orderStatus", "==", 1), orderBy("created", "desc"))

      //gets data with query
      const unsubscribe = onSnapshot(activeQ, (snapshot) => {
        let results = []
        snapshot.docs.forEach((doc) => {
          results.push({ ...doc.data(), id: doc.id })
        })

        //sets notification data
        setActiveOrders(results)

        //removes loading
        setActiveOrdersLoading(false)
      })
      //executes function
      return () => unsubscribe()
    }
  }, [props.activeKey])

  //job filter
  let jobFilters =
    activeOrders &&
    activeOrders.reduce((accumulator, item) => {
      const productName = item.selectedProduct.product.productName
      const existingItem = accumulator.find((filterItem) => filterItem.text === productName)

      if (existingItem) {
        existingItem.value = productName
      } else {
        accumulator.push({
          text: productName,
          value: productName,
        })
      }

      return accumulator
    }, [])

  //client filter
  let clientFIlters =
    activeOrders &&
    activeOrders.reduce((accumulator, item) => {
      const clientName = item.client.client
      const existingItem = accumulator.find((filterItem) => filterItem.text === clientName)

      if (existingItem) {
        existingItem.value = clientName
      } else {
        accumulator.push({
          text: clientName,
          value: clientName,
        })
      }

      return accumulator
    }, [])

  //return correct fill options
  const returnCorrectFillOptions = (value, record) => {
    if (record.selectedProduct.machine === "Cutter") {
      return (
        <>
          <CutterDetails order={record} />
        </>
      )
    } else {
      if (value.orderType === "Label") {
        return (
          <>
            <Text>
              <Redirect state={value} to={value.id}>
                View
              </Redirect>
            </Text>
          </>
        )
      } else if (value.orderType === "Tape") {
        return (
          <>
            <TapeOrderFill order={value} />
          </>
        )
      } else {
        return (
          <>
            <Button onClick={() => console.log(value)}>log</Button>
          </>
        )
      }
    }
  }

  //default columns for table
  const defaultColumns = [
    {
      title: "Nr.",
      dataIndex: "orderNumber",
      align: "center",
      sorter: (a, b) => a.orderNumber - b.orderNumber,
      render: (value, record) => OrderAndPrefix(record),
    },
    {
      title: "Job Name",
      dataIndex: ["selectedProduct", "product", "productName"],
      align: "center",
      filters: jobFilters,
      onFilter: (value, record) => record.selectedProduct.product.productName.startsWith(value),
      filterSearch: true,
    },
    {
      title: "Client",
      dataIndex: ["client", "client"],
      align: "center",
      filters: clientFIlters,
      onFilter: (value, record) => record.client.client.startsWith(value),
      filterSearch: true,
    },
    {
      title: "Manager",
      dataIndex: "user",
      align: "center",
      filters: designerUsersFilter,
      onFilter: (value, record) => record.user.startsWith(value),
      filterSearch: true,
    },
    {
      title: "Plate Location",
      dataIndex: ["selectedPlate", "plateLocation"],
      align: "center",
      render: (value, record) => {
        if (typeof record.selectedPlate === "object" && record.selectedPlate !== null) {
          return (
            <>
              <Text>{value}</Text>
            </>
          )
        } else {
          return (
            <>
              <Text>No plate</Text>
            </>
          )
        }
      },
    },
    {
      title: "Manufacturer",
      dataIndex: ["manufacturer", "company"],
      align: "center",
    },
    {
      title: "Material",
      dataIndex: ["selectedProduct", "material"],
      align: "center",
    },

    {
      title: "Machine",
      dataIndex: ["selectedProduct", "machine"],
      align: "center",
      filters: [
        {
          text: "Arsoma",
          value: "Arsoma",
        },
        {
          text: "Viva",
          value: "Viva",
        },
        {
          text: "Cutter",
          value: "Cutter",
        },
        {
          text: "Tape",
          value: "Tape",
        },
      ],
      onFilter: (value, record) => record.selectedProduct.machine.startsWith(value),
      filterSearch: true,
      render: (value) => {
        return returnProperMachineTag(value)
      },
    },
    {
      title: "Attachment",
      dataIndex: ["selectedProduct", "product", "productFileUrl"],
      align: "center",
      render: (value) => (
        <Link type="text" rel="noreferrer" target="_blank" href={value}>
          {value ? "Link" : ""}
        </Link>
      ),
    },
    {
      title: "Details",
      align: "center",
      render: (value, record) => {
        return (
          <>
            {returnCorrectFillOptions(value, record)}{" "}
            {record.requestedToStop ? <FillStopRequest data={record} /> : ""}
          </>
        )
      },
    },
    {
      title: "Created",
      dataIndex: ["created"],
      align: "center",
      sorter: (a, b) => a.created.seconds - b.created.seconds,
      render: (value) => (
        <>
          <Text>{moment.unix(value.seconds).format("DD/MM/YYYY")}</Text>
        </>
      ),
    },
  ]

  return (
    <>
      <Table
        style={{ marginTop: "15px" }}
        size="small"
        loading={activeOrdersLoading}
        rowKey={(record) => record.id}
        columns={defaultColumns}
        dataSource={activeOrders}
        pagination={{ defaultPageSize: "12", showSizeChanger: true }}
      />
    </>
  )
}
